import { render, staticRenderFns } from "./wechatdown.vue?vue&type=template&id=638c352c&"
import script from "./wechatdown.vue?vue&type=script&lang=ts&"
export * from "./wechatdown.vue?vue&type=script&lang=ts&"
import style0 from "./wechatdown.vue?vue&type=style&index=0&id=638c352c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports